import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Table, Label
} from "reactstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'

import DetailBloc from './Blocs/DetailBloc'
import moment from 'moment';

class Head extends Component {

    detailBloc = new DetailBloc()

    constructor(props) {
        super(props)
        this.state = {
          document: null
        }
        this.uuid = props.uuid
    }

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
          res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    componentDidMount() {
        this.detailBloc.detailDateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            detail: response,
                            document: response?.document_letter
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        
        // Pastikan menggunakan props yang dikirim dari parent
        const uuid = this.props.uuid || new URLSearchParams(this.props.location.search).get('uuid');
        this.detailBloc.fetchDetailDate({ uuid: uuid })
    }

    componentWillUnmount(){
      this.detailBloc.detailChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <CardTitle>Detail Laporan WFH</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Informasi List Laporan WFH Pegawai
                                    </CardSubtitle>
                                    <hr />
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Pengajuan WFH
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {
                                                            this.state.detail.employee_wfh_employee_name !== "" ? 
                                                                this.state.detail.employee_wfh_employee_name
                                                            : '-'
                                                        }
                                                    </>
                                                : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Tanggal WFH
                                        </label>
                                        <Col md="6">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {
                                                            this.state.detail.employee_wfh_detail_date !== "" ? 
                                                                this.dateParse(this.state.detail.employee_wfh_detail_date)
                                                            : '-'
                                                        }
                                                    </>
                                                : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Status
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {
                                                            this.state.detail.employee_wfh_status_name !== "" ? 
                                                                <label className={`badge rounded-pill bg-soft-primary font-size-12`}>{this.state.detail.employee_wfh_status_name}</label>
                                                            : '-'
                                                        }
                                                    </>
                                                : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    
                            {
                                (this.state.detail && this.state.detail.employee_wfh_status == -1) ?
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Alasan Penolakan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {
                                                            this.state.detail.employee_wfh_status_description !== "" ? 
                                                                this.state.detail.employee_wfh_status_description
                                                            : '-'
                                                        }
                                                    </>
                                                : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    :''
                            }
                                    <hr />
                                    
                                    <Row className="mb-3">
                                        <Col md="3"></Col>
                                        <Col md="9" className="text-end">
                                            <Link to={`/kepegawaian/pengajuan_wfh.html?detail&uuid=${this.state.detail?.employee_wfh_detail_employee_wfh_uuid || ''}`} className="waves-effect">
                                                <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

export default withRouter(Head)
// export default withRouter(IndexView);